// extracted by mini-css-extract-plugin
export var slides = "slides-module--slides--1s8cT";
export var panels = "slides-module--panels--155re";
export var detector = "slides-module--detector--6D9mi";
export var end = "slides-module--end--2mjeT";